import React from 'react';
import { motion } from 'framer-motion';
import { BuildingIcon } from 'lucide-react';
export function Footer() {
  return <footer className="w-full bg-bg-section border-t border-accent-primary border-opacity-10 py-8 md:py-12 px-4" data-id="element-57">
      <div className="max-w-6xl mx-auto" data-id="element-58">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 items-start" data-id="element-59">
          {/* Left: Brand */}
          <div data-id="element-60">
            <div className="flex items-center space-x-2 md:space-x-3 mb-3 md:mb-4" data-id="element-61">
              <div className="w-8 h-8 md:w-10 md:h-10 bg-accent-primary bg-opacity-10 rounded-lg flex items-center justify-center" data-id="element-62">
                <BuildingIcon className="h-5 w-5 md:h-6 md:w-6 text-accent-primary" aria-hidden="true" data-id="element-63" />
              </div>
              <h3 className="text-lg md:text-xl font-bold text-text-primary" data-id="element-64">
                Arquitectura Empresarial USA
              </h3>
            </div>
            <p className="text-sm md:text-base text-text-secondary leading-relaxed max-w-md" data-id="element-65">
              El sistema completo de arquitectura empresarial para crear, operar
              y blindar tu empresa estadounidense desde cualquier parte del
              mundo.
            </p>
          </div>

          {/* Right: Product Info */}
          <div className="md:text-right" data-id="element-66">
            <h4 className="text-base md:text-lg font-semibold text-text-primary mb-2 md:mb-3" data-id="element-67">
              El Ecosistema de los 4 Pilares
            </h4>
            <p className="text-sm md:text-base text-text-secondary mb-3 md:mb-4" data-id="element-68">
              Estructura empresarial completa e interdependiente
            </p>
            <div className="inline-flex flex-col items-start md:items-end" data-id="element-69">
              <div className="flex items-center space-x-2 mb-2" data-id="element-70">
                <span className="text-base md:text-lg text-text-secondary line-through" data-id="element-71">
                  $47
                </span>
                <span className="text-xs md:text-sm font-semibold text-accent-primary bg-accent-primary bg-opacity-10 px-2 py-1 rounded" data-id="element-72">
                  86% OFF
                </span>
              </div>
              <div className="inline-flex items-center space-x-2 bg-bg-card border border-accent-primary border-opacity-20 rounded-lg px-3 md:px-4 py-1.5 md:py-2" data-id="element-73">
                <span className="text-xl md:text-2xl font-bold text-accent-primary" data-id="element-74">
                  $6.39
                </span>
                <span className="text-sm md:text-base text-text-secondary" data-id="element-75">
                  USD
                </span>
              </div>
            </div>
          </div>
        </motion.div>

        {/* Bottom */}
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="mt-6 md:mt-8 pt-6 md:pt-8 border-t border-accent-primary border-opacity-10 text-center" data-id="element-76">
          <p className="text-xs md:text-sm text-text-secondary" data-id="element-77">
            © {new Date().getFullYear()} Arquitectura Empresarial USA. Todos
            los derechos reservados. Material educativo.
          </p>
        </motion.div>
      </div>
    </footer>;
}